import * as React from 'react';

import classNames from 'classnames';
import type { IColorModifier } from '../ColorHelper';
import { getColorModifierClasses } from '../ColorHelper';

interface ITitleProps extends IColorModifier {
	size?: number;
}

export default class Title extends React.Component<ITitleProps, {}> {
	public render() {
		const { size } = this.props;

		const classes = classNames(
			'title',
			getColorModifierClasses(this.props),
			size ? `is-${size}` : ''
		);

		return <p className={classes}>{this.props.children}</p>;
	}
}
